<!-- ===================================================================== -->
<!-- BULK ACTIONS — Desktop only (require checkbox selection)              -->
<!-- ===================================================================== -->
<div class="vc-treatments__bulk-actions">
  <button
    pButton
    class="p-button-primary p-button-sm"
    label="{{ 'APPOINTMENT.SCHEDULE' | translate }}"
    icon="fas fa-calendar"
    [disabled]="!!!this.selectedTreatments.length"
    *ngIf="this.hasPermission('APPOINTMENTS.CREATE') && !adminReadonly"
    (click)="this.scheduleAppointment()"
    size="small"
  ></button>
  <button
    pButton
    class="p-button-danger p-button-sm"
    label="{{ 'COMMON.REMOVE' | translate }}"
    icon="fas fa-trash"
    [disabled]="!!!this.selectedTreatments.length"
    *ngIf="canModifyPatientTreatments()"
    (click)="this.confirmDeleteSelected()"
    size="small"
  ></button>
</div>

<!-- ===================================================================== -->
<!-- DESKTOP TABLE                                                         -->
<!-- ===================================================================== -->
<div class="vc-treatments__table">
  <p-table
    [value]="treatments"
    [(selection)]="selectedTreatments"
    styleClass="Table"
    [autoLayout]="true"
    responsiveLayout="scroll"
    (sortFunction)="customSort($event)"
    [customSort]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="vc-treatments__select-column">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th id="site">{{ "COMMON.SITE" | translate }}</th>
        <th id="treatment-name">{{ "COMMON.TREATMENT.NAME" | translate }}</th>
        <th id="price">{{ "COMMON.PRICE" | translate }}</th>
        <th id="appointment-date" pSortableColumn="appointment.start">
          {{ "APPOINTMENT.INFO.DATE" | translate
          }}<p-sortIcon field="appointment.start"></p-sortIcon>
        </th>
        <th id="status">{{ "PAYMENT.STATUS" | translate }}</th>
        <th id="actions">{{ "COMMON.ACTIONS" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-treatment>
      <tr>
        <td>
          <p-tableCheckbox [value]="treatment"></p-tableCheckbox>
        </td>
        <td>
          {{ treatment.appointment?.calendar.site.name }}
        </td>
        <td>
          {{ treatment.treatment.category.name }}<br />
          <strong> {{ treatment.treatment.name }}</strong>
        </td>
        <td>
          {{ treatment.price | number : "1.2-2" }}
          {{ getCurrencyLabel(treatment) }}
        </td>
        <td>
          <p-tag
            *ngIf="treatment.appointment"
            class="Date__tag"
            [pTooltip]="
              'STATUS.' +
                (treatment.appointment.status || { name: 'Undefined' }).name
                | translate
            "
            [style]="{
              backgroundColor: appointmentStatusColor(treatment),
              color: appointmentStatusTextColor(treatment)
            }"
            [value]="moment(treatment.appointment.start).format('DD-MM-YYYY')"
            [icon]="'fa fa-calendar'"
            (click)="this.redirectCalendar(treatment.appointment)"
          ></p-tag>
        </td>
        <td>
          <div class="vc-treatments__payment-cell">
            <button
              pButton
              *ngIf="canManageTreatmentPayments()"
              class="p-button-sm"
              [ngClass]="
                isPaid(treatment)
                  ? 'p-button-outlined'
                  : 'p-button-primary'
              "
              [label]="getPaymentButtonLabel(treatment)"
              [icon]="getPaymentButtonIcon(treatment)"
              [disabled]="adminReadonly"
              [pTooltip]="getPaymentTooltip(treatment)"
              tooltipPosition="top"
              (click)="payDialog(treatment)"
              size="small"
            ></button>
            <small class="vc-treatments__payment-summary" *ngIf="isPaid(treatment)">
              {{ getPaymentSummaryLabel(treatment) }}
            </small>
          </div>
        </td>
        <td>
          <button
            *ngIf="canModifyPatientTreatments()"
            pButton
            [label]="'COMMON.EDIT' | translate"
            class="p-button-sm p-button-outlined"
            icon="fas fa-pen"
            (click)="this.editTreatment(treatment)"
            size="small"
          ></button>
          <app-delete-button-treatment-patient
            *ngIf="canModifyPatientTreatments()"
            [payload]="treatment"
            [onDelete]="onDelete"
          ></app-delete-button-treatment-patient>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-treatment>
      <tr>
        <td colspan="7">{{ "TREATMENTS.EMPTY" | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- ===================================================================== -->
<!-- MOBILE CARDS — Feed / Timeline style                                  -->
<!-- ===================================================================== -->
<div class="vc-treatments__cards">

  <!-- Empty state -->
  <div class="vc-treatments__empty" *ngIf="!treatments?.length">
    <i class="fas fa-briefcase-medical"></i>
    <span>{{ "TREATMENTS.EMPTY" | translate }}</span>
  </div>

  <!-- Treatment card -->
  <div class="vc-treatments__card" *ngFor="let treatment of treatments"
       [class.vc-treatments__card--paid]="treatment.payments.length > 0"
       [class.vc-treatments__card--unpaid]="treatment.payments.length === 0">

    <!-- Row 1: Category + Actions -->
    <div class="vc-treatments__card-top">
      <span class="vc-treatments__card-category">
        {{ treatment.treatment.category.name }}
      </span>
      <div class="vc-treatments__card-actions">
        <button
                *ngIf="canModifyPatientTreatments()"
                pButton icon="fas fa-pen"
                [label]="'COMMON.EDIT' | translate"
                class="p-button-text p-button-sm"
                (click)="this.editTreatment(treatment)"></button>
        <app-delete-button-treatment-patient
          *ngIf="canModifyPatientTreatments()"
          [payload]="treatment"
          [onDelete]="onDelete">
        </app-delete-button-treatment-patient>
      </div>
    </div>

    <!-- Row 2: Treatment name + Price -->
    <div class="vc-treatments__card-main">
      <span class="vc-treatments__card-name">{{ treatment.treatment.name }}</span>
      <span class="vc-treatments__card-price">
        {{ treatment.price | number : "1.2-2" }} {{ getCurrencyLabel(treatment) }}
      </span>
    </div>

    <!-- Row 3: Meta info — appointment date, payment status -->
    <div class="vc-treatments__card-meta">
      <!-- Appointment date -->
      <div class="vc-treatments__card-detail" *ngIf="treatment.appointment">
        <span class="vc-treatments__card-detail-label">{{ 'APPOINTMENT.INFO.DATE' | translate }}</span>
        <span class="vc-treatments__card-detail-value"
            [style.color]="appointmentStatusColor(treatment)"
              (click)="this.redirectCalendar(treatment.appointment)">
          <i class="fas fa-calendar"></i>
          {{ moment(treatment.appointment.start).format('DD/MM/YYYY') }}
        </span>
      </div>

      <!-- Payment status -->
      <div class="vc-treatments__card-detail" *ngIf="isPaid(treatment)">
        <span class="vc-treatments__card-detail-label">{{ 'PAYMENT.STATUS' | translate }}</span>
        <span class="vc-treatments__card-detail-value vc-treatments__card-detail-value--success">
          <i class="fas fa-check-circle"></i>
          {{ getPaymentSummaryLabel(treatment) }}
        </span>
      </div>
    </div>

    <!-- Row 4: Action buttons -->
    <div class="vc-treatments__card-footer">
      <button
              *ngIf="canManageTreatmentPayments()"
              pButton
              [icon]="getPaymentButtonIcon(treatment)"
              [label]="getPaymentButtonLabel(treatment)"
              class="p-button-sm vc-treatments__pay-btn"
              [ngClass]="isPaid(treatment) ? 'p-button-outlined' : ''"
              [disabled]="adminReadonly"
              (click)="payDialog(treatment)"></button>

      <button *ngIf="!treatment.appointment && canScheduleAppointments()"
              pButton icon="fas fa-calendar-plus"
              [label]="'APPOINTMENT.SCHEDULE' | translate"
              class="p-button-sm p-button-outlined vc-treatments__schedule-btn"
              (click)="this.scheduleAppointmentSingle(treatment)"></button>
    </div>
  </div>
</div>
